import React, { Component, lazy } from 'react';
// Some component unit tests are failing.
// eslint-disable-next-line no-restricted-imports
import { translate } from 'react-polyglot';
import { withRouter } from 'react-router';
import MaskedInput from 'react-text-mask';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { Loading } from 'components/cosmos';
import { Checkbox } from 'components/cosmos/checkbox';
import Tooltip from 'components/cosmos/tooltip';
import { DropdownItem } from 'components/dropdown';
import ErrorState from 'components/errorState';
import { Form, FormControl } from 'components/form';
import { Grid } from 'components/grid';
import { InputDropdown } from 'components/input';
import { InputGroup } from 'components/input/group';
import { Loader } from 'components/loader';
import { PreviewPageThumbnail } from 'components/svg/images';
import { ROUTES } from 'configs/routes/constants';
import {
  invokeEvent,
  showSurvey,
  SURVEY_EVENTS,
  SURVEY_ID_LIST
} from 'configs/Survicate';
import { ShellContext } from 'contexts/shellContext';
import withSuspense from 'hoc/withSuspense';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { ArrivedFrom, DatahubEventsService } from 'modules/app/services';
import {
  EVENT_ACTIONS,
  EVENTS_INTERACTIONS,
  EVENTS_CATEGORY,
  EVENTS_LABELS
} from 'modules/app/services/datahub/constants';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { buildInteractionEventData } from 'modules/app/services/datahub/helper';
import ViewContentCreateSchema from 'modules/app/services/datahubEvents/module/viewContentCreateSchema';
import ViewContentEditSchema from 'modules/app/services/datahubEvents/module/viewContentEditSchema';
import { CATEGORIES, LABELS, ACTIONS } from 'modules/app/services/ga/constants';
import GtagService from 'modules/app/services/ga/GtagService';
import AuthService from 'modules/auth/AuthService';
import { FileLibraryProvider } from 'modules/configManager/types';
import {
  ContentService,
  ContentPageService,
  ContentPagePreventLeaveService
} from 'modules/content';
import HotmartPlayerActiveBadge from 'modules/content/components/HotmartPlayerActiveBadge';
import { Rerender } from 'modules/content/components/reRender';
import {
  CONTENT_PAGE_TYPE,
  getContentPageTitle
} from 'modules/content/contentPageTitles';
import DrippingSection from 'modules/content/dripping/components/drippingSection';
import { PageType } from 'modules/content/moduleService/ModuleTypes';
import { FeatureToggles } from 'modules/featureToggle';
import { FileService } from 'modules/file';
import { FileAttachmentSection } from 'modules/file/components';
import FilePlayerGroup from 'modules/file/components/player/FilePlayerGroup';
import { ENTITY_TYPE, MAX_PAGE_BACKGROUND_SIZE } from 'modules/file/constants';
import MembershipService from 'modules/membership/MembershipService';
import { MembershipEventService } from 'modules/membershipEvent';
import { EVENTS } from 'modules/membershipEvent/constants';
import { UiService } from 'modules/ui';
import { ALERT } from 'modules/ui/constants';
import PropTypes from 'prop-types';
import { v4 } from 'uuid';

import ModuleEditorParamsUtils from './../moduleEditor/ModuleEditorParamsUtils';
import ComplementaryReading from './complementaryReading/ComplementaryReading';
import ContentBasePage from './ContentBasePage';
import ContentPreventLeave from './ContentPreventLeave';
import Dripping from './dripping/Dripping';
import DrippingValidation from './dripping/DrippingValidation';
import HotmartPlayerInactiveBadge from './hotmartPlayerInactiveBadge';
import Language from './language';
import BackgroundUpload from './media/BackgroundUpload';
import PublishAndNotifyDropdown from './PublishAndNotifyDropdown';
import PublishAndNotifyModal from './PublishAndNotifyModal';
import PublishQuicklyModal from './publishQuicklyModal';
import Tags from './tags/Tags';

import { DrippingStore } from '../dripping/stores';

import { uploadNotifySave } from '@hotmart/club-files-ui';

import './ContentForm.scss';

const ContentEditorUploadWrapper = withSuspense(
  lazy(() => import('components/editor/ContentUploadWrapper'))
);

@inject((stores) => ({
  MembershipStore: stores.MembershipStore,
  MembershipEventStore: stores.MembershipEventStore,
  StreamingStore: stores.StreamingStore,
  ContentPageStore: stores.ContentPageStore,
  modulesList: stores.ContentStore.modulesList,
  modulesLoaded: stores.ContentStore.loaded,
  tags: stores.ContentPageStore.tags,
  mediaVideoUrl: stores.ContentPageStore.mediaVideoUrl,
  isDrippingByClassEnabled: stores.FeatureToggleStore.featureToggles.get(
    FeatureToggles.DrippingByClass
  ),
  isDrippingDirty: stores.DrippingStore.isDirty
}))
@translate()
@withRouter
@observer
export default class ContentForm extends Component {
  static contextType = ShellContext;
  static propTypes = {
    ContentPageStore: MobxPropTypes.objectOrObservableObject,
    history: PropTypes.object,
    match: PropTypes.shape({
      params: PropTypes.shape({
        pageId: PropTypes.string,
        moduleId: PropTypes.string,
        id: PropTypes.string
      })
    }),
    MembershipStore: MobxPropTypes.objectOrObservableObject,
    MembershipEventStore: MobxPropTypes.objectOrObservableObject,
    t: PropTypes.func,
    modulesList: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    modulesLoaded: PropTypes.bool
  };

  state = {
    loaded: true,
    pageBackgroundImg: null,
    selectOpened: false,
    firstLoad: false,
    isPublishAndNotifyModalOpen: false,
    isNotifying: false,
    lastPageId: null,
    showPublishQuicklyModal: false,
    drippingErrors: DrippingValidation.initialState,
    fetchPageError: false,
    isSubmitting: false
  };

  static formRef = React.createRef();

  constructor(props) {
    super(props);

    this.inputNameRef = React.createRef();
    this.reRenderRef = React.createRef();
  }

  componentWillUnmount() {
    ContentPageService.clear();
    uploadNotifySave(v4());
  }

  componentDidMount() {
    this.fetchData();
    this.dispatchDatahubEvent();
  }

  dispatchDatahubEvent = () => {
    const eventParams = {
      pageType: PageType.Content,
      arrivedFrom: ArrivedFrom.CONTENT_LIST
    };

    const schema = this.props.match.params.id
      ? new ViewContentEditSchema(eventParams)
      : new ViewContentCreateSchema(eventParams);

    DatahubEventsService.sendEvent({ schema });
  };

  fetchData = async () => {
    const { modulesLoaded } = this.props;
    const {
      params: { id, moduleId }
    } = this.props.match;

    if (id) {
      try {
        await ContentPageService.getPage(id);
      } catch (error) {
        this.setState({ fetchPageError: true });
      }
    } else {
      ContentPageService.moduleId = moduleId;
      ContentPagePreventLeaveService.updateSnapshot();
    }

    if (!modulesLoaded) {
      const seasonId = ModuleEditorParamsUtils.getSeasonParam();
      const extra = ModuleEditorParamsUtils.getExtraParam();

      ContentService.fetchModulesList(seasonId, extra);
    }

    ContentService.lastEditedModule = moduleId;
    this.setState({ firstLoad: true });
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    UiService.smoothScroll('body', 500);
  };

  clear = () => {
    const { params } = this.props.match;

    ContentForm.formRef.current.setSubmitted(false);
    ContentPageService.clear();
    ContentPageService.moduleId = params.moduleId;
  };

  get actions() {
    const actions = {};
    const { params } = this.props.match;

    if (params.id) {
      actions.onPublish = this.publish.bind(this);
      actions.onVisualize = this.visualize.bind(this);
    }

    return actions;
  }

  newPage = () => {
    this.toggleLoader();
    this.clear();

    this.reRenderRef.current?.reRender();
    this.inputNameRef.current?.focus();

    this.toggleLoader();
  };

  visualize = () => {
    ContentPageService.contentPreview(
      ContentPageService.pageId,
      null,
      ModuleEditorParamsUtils.getSeasonParam()
    );
  };

  publish = async ({ notify = false } = {}) => {
    const isValidForm = ContentForm.formRef.current.submitAction();

    if (!isValidForm) {
      return;
    }

    this.toggleLoader();

    const {
      response: { id: pageId }
    } = await ContentForm.formRef.current.submit();

    const isPublished = ContentPageService.published;
    const modules = null;
    const showAlert = false;

    const response = await ContentPageService.publish(
      [ContentPageService.pageId || pageId],
      !isPublished,
      modules,
      showAlert,
      notify
    );

    const seasonId = ModuleEditorParamsUtils.getSeasonParam();

    await ContentService.fetchModulesList(seasonId);

    if (response) {
      ContentPageService.published = !ContentPageService.published;
    }

    ContentPagePreventLeaveService.updateSnapshot();

    this.toggleLoader();

    return response;
  };

  publishAndNotify = async () => {
    this.setState({ isNotifying: true });

    const response = await this.publish({ notify: true });

    if (response) {
      ContentPageService.published = true;

      GtagService.sendClick({
        category: CATEGORIES.CLUB_ADMIN_CONTENT,
        where: ACTIONS.PUBLISH_AND_NOTIFY,
        label: LABELS.PUBLISH_AND_NOTIFY
      });

      DatahubService.sendEvent({
        action: EVENT_ACTIONS.INTERACT,
        event: buildInteractionEventData({
          category: EVENTS_CATEGORY.CONTENT.NAME,
          label: EVENTS_LABELS.CONTENT.PUBLISH_AND_NOTIFY,
          action: EVENTS_INTERACTIONS.CLICK
        })
      });

      if (response.alreayNotifiedByEmail) {
        UiService.setAlertInfo(
          'publish_and_notify_error',
          {},
          ALERT.TIMEOUT.LONG
        );
      } else {
        UiService.setAlertSuccess(
          'publish_and_notify_success',
          {},
          ALERT.TIMEOUT.LONG
        );
      }
    }
  };

  openPublishAndNotifyModal = () => {
    this.setState({ isPublishAndNotifyModalOpen: true });
  };

  closePublishAndNotifyModal = () => {
    this.setState({ isPublishAndNotifyModalOpen: false });
  };

  onConfirmPublishAndNotifyModal = (dontShowAgain) => {
    if (dontShowAgain) {
      MembershipEventService.dismissEvent(EVENTS.PUBLISH_AND_NOTIFY_INFO);
    }

    this.publishAndNotify();

    this.closePublishAndNotifyModal();
  };

  openActivePlayerInfoModal = () => {
    this.setState({ isActivePlayerInfoModalOpen: true });
  };

  closeActivePlayerInfoModal = () => {
    this.setState({ isActivePlayerInfoModalOpen: false });
  };

  handleSubmit = async (data) => {
    this.changeName(data.name);
    this.toggleLoader();

    const response = await ContentPageService.save();

    if (response !== false) {
      const seasonId = ModuleEditorParamsUtils.getSeasonParam();
      const extra = ModuleEditorParamsUtils.getExtraParam();

      ContentService.fetchModulesList(seasonId, extra);

      const { isMembership } = this.context;

      if (isMembership) {
        showSurvey(SURVEY_ID_LIST.CONTENT_MANAGEMENT);
      }
    }

    this.toggleLoader();

    return {
      data,
      response
    };
  };

  saveThenNavigate = async () => {
    const { history, match } = this.props;

    this.setState({ isSubmitting: true });

    try {
      const result = await ContentForm.formRef.current.submit();
      const success = result !== false && result?.response !== false;

      if (success) {
        const isNew = !match.params.id;
        const hasDripping = DrippingStore.items?.length > 0;

        this.showSurveyAfterPublishQuicklyModal = isNew && hasDripping;
        DrippingStore.clear();

        if (!ContentPageService.published) {
          this.setState({
            showPublishQuicklyModal: true,
            lastPageId: result.response.id
          });

          return;
        }

        history.push(`${ROUTES.CONTENT.LIST}${window.location.search}`);
      }
    } catch {
      /* empty */
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  handlePublishQuicklyModalOk = async () => {
    const {
      match: {
        params: { id }
      }
    } = this.props;

    const pages = [this.state.lastPageId || id];
    const isPublished = false;

    await ContentPageService.publish(pages, !isPublished);

    this.handlePublishQuicklyModalCancel();
  };

  handlePublishQuicklyModalCancel = () => {
    this.setState({ showPublishQuicklyModal: false });

    if (this.showSurveyAfterPublishQuicklyModal) {
      invokeEvent(SURVEY_EVENTS.DRIPPING_BY_CLASS);
    }

    if (this.props.ContentPageStore.page.createAnotherField) {
      this.newPage();
      return;
    }

    if (!this.props.match.params.id) {
      invokeEvent(SURVEY_EVENTS.OLD_CONTENT_CREATE);
    }

    this.props.history.push(`${ROUTES.CONTENT.LIST}${window.location.search}`);
  };

  get academyBadgeTypeOptions() {
    return [
      {
        value: 'RESEARCH_AND_DEVELOPMENT',
        label: this.props.t('academy.badges.RESEARCH_AND_DEVELOPMENT')
      },
      {
        value: 'MANAGEMENT_AND_CAREER',
        label: this.props.t('academy.badges.MANAGEMENT_AND_CAREER')
      },
      {
        value: 'SALES_AND_DISCLOSURE',
        label: this.props.t('academy.badges.SALES_AND_DISCLOSURE')
      },
      {
        value: 'LANGUAGE_AND_CONTENT',
        label: this.props.t('academy.badges.LANGUAGE_AND_CONTENT')
      },
      {
        value: 'METRICS_AND_RESULTS',
        label: this.props.t('academy.badges.METRICS_AND_RESULTS')
      }
    ];
  }

  get isBackgroundUploadEnabled() {
    const { medias } = this.props.ContentPageStore;
    const { isStreamingEnabled } = this.props.MembershipStore;
    const { isMembership } = this.context;
    const isMediasEmpty = medias.length === 0;

    return (
      (MembershipService.isMidnight && isMediasEmpty) ||
      (isMembership && (isMediasEmpty || !isStreamingEnabled))
    );
  }

  get academyBadgeTypeValue() {
    const { academyBadgeType } = this.props.ContentPageStore;

    if (academyBadgeType) {
      const academyBadge = this.academyBadgeTypeOptions.find(
        (c) => c.value === academyBadgeType
      );

      return academyBadge && academyBadge.label;
    }

    return null;
  }

  get isModulePublic() {
    const { moduleId } = this.props.match.params;

    const { publicModule } =
      this.props.modulesList.find((module) => module.id === moduleId) || {};

    return publicModule;
  }

  onChange = (name, value) => {
    const state = this.state;

    state[name] = value;
    this.setState(state);
  };

  onContentChange = (content) => {
    this.setState({ content });
  };

  onLanguageChange = (language) => {
    ContentPageService.language = language;
  };

  onSignLanguageChange = (signLanguage) => {
    ContentPageService.signLanguage = signLanguage;
  };

  onTagChange = (tags) => {
    ContentPageService.tags = tags;
  };

  setMediaUrl = (url) => {
    ContentPageService.mediaVideoUrl = url;
  };

  onBackgroundImageChange = (event) => {
    ContentPageService.backgroundImage = event.target.value;
  };

  setKnowledgeArea = (knowledgeArea) => {
    this.setState({ knowledgeArea });
  };

  setAcademyBadgeType = (value) => {
    ContentPageService.academyBadgeType = value;
  };

  isOpened = (opened) => {
    this.setState({ selectOpened: opened });
  };

  onArticleChange = (articles) => {
    ContentPageService.complementaryReadings = articles;
  };

  onFilesChange = (attachments) => {
    ContentPageService.attachments = attachments;
  };

  onHotpassValueChange = (e) => {
    const { value } = e.target;

    ContentPageService.hotPassValue = value.replace(/_/g, '');
  };

  onVideosChange = (medias) => {
    const sortedMedias =
      FileService.sortMediasByOrderOrCreationDate(medias || []) || [];

    ContentPageService.medias = sortedMedias;
  };

  changeName = (name) => {
    ContentPageService.name = name;
  };

  // eslint-disable-next-line no-dupe-class-members
  onContentChange = (e) => {
    const { value } = e.target;

    ContentPageService.content = value;
  };

  changeLiberationDays = (e) => {
    ContentPageService.liberationDays = e.target.value;
  };

  changeLiberationType = (liberationType) => {
    ContentPageService.liberationType = liberationType;
  };

  changeHasDuration = (hasDuration) => {
    ContentPageService.hasDuration = hasDuration;
  };

  changeLiberationDate = (liberationDate) => {
    ContentPageService.liberationDate = liberationDate;
  };

  changeDurationDays = (durationDays) => {
    ContentPageService.durationDays = durationDays;
  };

  toggleLoader = () => {
    this.setState((prevState) => ({ loaded: !prevState.loaded }));
  };

  syncFormChanges = (inputs) => {
    Object.assign(this.props.ContentPageStore.page, { ...inputs });
  };

  onError = (message, data) => UiService.setAlertError(message, data);

  handleValidate = () => {
    const {
      ContentPageStore: { page }
    } = this.props;
    const {
      hasDuration,
      liberationType,
      liberationDays,
      liberationDate,
      durationDays
    } = page;
    const drippingValidation = new DrippingValidation(
      hasDuration,
      liberationType
    );
    const drippingErrors = drippingValidation.validate({
      liberationDays,
      liberationDate,
      durationDays
    });

    this.setState({ drippingErrors });

    return !drippingValidation.hasError;
  };

  // eslint-disable-next-line complexity
  renderFilePlayer() {
    const { t, ContentPageStore, MembershipStore, StreamingStore } = this.props;
    const { medias, mediaVideoUrl } = ContentPageStore;
    const { isStreamingEnabled } = MembershipStore;
    const { fileLibraryProvider } = StreamingStore;

    const showMediaUpload =
      AuthService.isAdmin() || AuthService.isOwner() || isStreamingEnabled;

    return (
      (!this.isModulePublic ||
        MembershipService.isStreamingFreeContentEnabled) &&
      showMediaUpload && (
        <>
          <div className="_d-flex _flex-column _align-items-center _flex-sm-row _mb-1">
            {fileLibraryProvider === FileLibraryProvider.Club && (
              <label>{t('general.media')}</label>
            )}
            {fileLibraryProvider === FileLibraryProvider.PlayerBackoffice && (
              <>
                <label className="_mr-2">
                  {t('player_backoffice.content_form.media.label')}
                </label>
                <Tooltip
                  content={t('player_backoffice.content_form.media.tooltip')}
                  position={Tooltip.TOOLTIP_POSITION.RIGHT}
                >
                  <FontAwesomeIcon icon={['fal', 'question-circle']} />
                </Tooltip>
              </>
            )}
            {isStreamingEnabled && <HotmartPlayerActiveBadge />}
            {!isStreamingEnabled && <HotmartPlayerInactiveBadge />}
          </div>

          <FilePlayerGroup
            isPageFreeContent={this.isModulePublic}
            mediaUrl={mediaVideoUrl}
            medias={medias}
            sortedMedias={medias}
            onCancelUpload={FileService.delete}
            onItemsChange={this.onVideosChange}
            setMediaUrl={this.setMediaUrl}
            setCentralError={this.onError}
            fileLibraryProvider={fileLibraryProvider}
          />
        </>
      )
    );
  }

  renderAcademyBadgeTypeOptions = (academyBadgeTypeOptions) => (
    <DropdownItem
      key={academyBadgeTypeOptions.value}
      onClick={() => this.setAcademyBadgeType(academyBadgeTypeOptions.value)}
      isSelected={this.academyBadgeTypeValue === academyBadgeTypeOptions.label}
    >
      {academyBadgeTypeOptions.label}
    </DropdownItem>
  );

  // eslint-disable-next-line complexity
  render() {
    const { firstLoad, fetchPageError } = this.state;

    if (!firstLoad) {
      return <Loader fixed />;
    }

    if (fetchPageError) {
      return <ErrorState />;
    }

    const {
      loaded,
      selectOpened,
      drippingErrors,
      isPublishAndNotifyModalOpen,
      showPublishQuicklyModal,
      isSubmitting
    } = this.state;
    const {
      MembershipEventStore,
      match: {
        params: { id }
      },
      MembershipStore: { academy, emailNotificationBeta, name },
      ContentPageStore: {
        page,
        tags,
        complementaryReadings,
        hotPassValue,
        attachments,
        backgroundImage,
        snapshot
      },
      isDrippingByClassEnabled,
      isDrippingDirty,
      t
    } = this.props;
    const isEditingItem = id;
    const events = MembershipEventStore?.events;
    const shouldShowNotifyModal = events.includes(
      EVENTS.PUBLISH_AND_NOTIFY_INFO
    );
    const shouldDisableNotify = Boolean(page.liberationType);
    const shouldRenderDropdown =
      !ContentPageService.published && emailNotificationBeta;
    const renderPublishAndNotifyModal =
      emailNotificationBeta && shouldShowNotifyModal;
    const classHotpassInput = classNames('hotpass__input', {
      'hotpass__input--extended': selectOpened
    });
    const headerClassName = classNames({ 'is-beta': shouldRenderDropdown });
    const formTitle = getContentPageTitle(
      CONTENT_PAGE_TYPE.CONTENT,
      isEditingItem
    );
    const currentSnapshot = ContentPagePreventLeaveService.getCurrentSnapshot();

    return (
      <Form
        className="content__form"
        ref={ContentForm.formRef}
        onSubmit={this.handleSubmit.bind(this)}
        onChange={this.syncFormChanges.bind(this)}
        onValidate={this.handleValidate}
      >
        <ContentBasePage className="content__grid">
          <ContentBasePage.Header title={formTitle}>
            <ContentBasePage.Header.Actions className={headerClassName}>
              <ContentBasePage.Header.Actions.Default
                isPublished={page.published}
                {...this.actions}
              />
              {shouldRenderDropdown && (
                <PublishAndNotifyDropdown
                  publishButtonBig
                  openModal={this.openPublishAndNotifyModal}
                  onPublish={this.publish}
                  onPublishAndNotify={this.publishAndNotify}
                  shouldShowModal={shouldShowNotifyModal}
                  disable={false}
                  disableNotify={shouldDisableNotify}
                />
              )}
            </ContentBasePage.Header.Actions>
          </ContentBasePage.Header>

          <Rerender ref={this.reRenderRef}>
            <Grid block role="region" aria-labelledby="content-heading">
              <h2 id="content-heading">{t('general.content')}</h2>

              <FormControl>
                <InputGroup
                  required
                  ref={this.inputNameRef}
                  name="name"
                  autoComplete="off"
                  labelValue="general.name"
                  value={page.name}
                  placeholder="page_content.name_placeholder"
                  maxLength="255"
                />
              </FormControl>

              {this.renderFilePlayer()}

              {this.isBackgroundUploadEnabled && (
                <BackgroundUpload
                  reusable
                  description="page_content.page_thumbnail.description_v2"
                  labelValue="page_content.page_thumbnail.title"
                  value={backgroundImage}
                  onCancelUpload={FileService.onCancelUpload}
                  placeholderImg={PreviewPageThumbnail}
                  onChange={this.onBackgroundImageChange}
                  entity={ENTITY_TYPE.PAGE_BACKGROUND_IMG}
                  entityId={this.props.match.params.id}
                  maxFileSize={MAX_PAGE_BACKGROUND_SIZE}
                  setCentralError={this.onError}
                />
              )}

              <label htmlFor="content">{t('general.text')}</label>
              <ContentEditorUploadWrapper
                upsell
                id="content"
                value={page.content}
                onChange={this.onContentChange}
                placeholder="general.editor_placeholder"
              />

              <Language
                language={page?.pageLanguage?.language}
                signLanguage={page?.pageLanguage?.signLanguage}
                onLanguageChange={this.onLanguageChange}
                onSignLanguageChange={this.onSignLanguageChange}
              />
              <Tags tags={tags} onTagChange={this.onTagChange} />
            </Grid>

            <Grid block role="region" aria-labelledby="extra-content-heading">
              <h2 id="extra-content-heading">{t('general.extras')}</h2>

              <FileAttachmentSection
                files={attachments}
                onItemsChange={this.onFilesChange}
                onCancelUpload={FileService.onCancelUpload}
                setCentralError={this.onError}
              />

              <ComplementaryReading
                articles={complementaryReadings}
                onArticleChange={this.onArticleChange}
              />
            </Grid>

            {(!isDrippingByClassEnabled || academy) && (
              <Grid block role="region" aria-labelledby="config-heading">
                <h2 id="config-heading">{t('general.configs')}</h2>

                {!isDrippingByClassEnabled && (
                  <Dripping
                    hasDuration={page.hasDuration}
                    durationDays={page.durationDays}
                    liberationDate={page.liberationDate}
                    liberationDays={page.liberationDays}
                    liberationType={page.liberationType}
                    changeLiberationType={this.changeLiberationType}
                    changeLiberationDays={this.changeLiberationDays}
                    changeHasDuration={this.changeHasDuration}
                    changeLiberationDate={this.changeLiberationDate}
                    changeDurationDays={this.changeDurationDays}
                    errors={drippingErrors}
                  />
                )}

                {academy && (
                  <div className={classHotpassInput}>
                    <label>{t('general.hot_pass')}</label>
                    <div className="hotpass__value__wrapper">
                      <p className="secondary">{t('academy.lesson_value')}</p>
                      <MaskedInput
                        guide={false}
                        mask={[/\d/, /\d/, /\d/, /\d/]}
                        className=""
                        value={hotPassValue}
                        onChange={this.onHotpassValueChange}
                      />
                    </div>
                    <div className="knowledge_area__wrapper">
                      <p className="secondary">{t('academy.knowledge_area')}</p>
                      <InputDropdown
                        selected={Boolean(this.academyBadgeTypeValue)}
                        isOpened={this.isOpened}
                        classNameMenu="input-dropdown__menu"
                      >
                        {this.academyBadgeTypeOptions.map(
                          this.renderAcademyBadgeTypeOptions
                        )}
                      </InputDropdown>
                    </div>
                  </div>
                )}
              </Grid>
            )}

            {isDrippingByClassEnabled && (
              <DrippingSection pageType={PageType.Content} />
            )}
          </Rerender>

          <ContentBasePage.Footer
            onSubmitAndReturn={this.saveThenNavigate}
            isSubmitDisabled={isSubmitting}
          >
            {!isEditingItem && (
              <FormControl>
                <Checkbox
                  id="createAnotherField"
                  name="createAnotherField"
                  label={t('page_content.create_another')}
                  className="_mb-0"
                />
              </FormControl>
            )}
          </ContentBasePage.Footer>
        </ContentBasePage>

        {showPublishQuicklyModal && (
          <PublishQuicklyModal
            onClose={this.handlePublishQuicklyModalCancel}
            onPublish={this.handlePublishQuicklyModalOk}
          />
        )}

        {renderPublishAndNotifyModal && (
          <PublishAndNotifyModal
            productName={name}
            isOpen={isPublishAndNotifyModalOpen}
            onCancel={this.closePublishAndNotifyModal}
            onConfirm={this.onConfirmPublishAndNotifyModal}
          />
        )}

        {!loaded && <Loading center />}

        <ContentPreventLeave
          snapshot={snapshot}
          current={currentSnapshot}
          isForceDirty={isDrippingDirty}
        />
      </Form>
    );
  }
}
